import { ReactNode, useState } from "react";
import { Stack, StackProps, IconButton, CircularProgress } from "@mui/material";
import { GpsFixedOutlined } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { getCurrentPickupLocation } from "../helpers";
import { useField } from "formik";

interface Props extends StackProps {
    children?: ReactNode;
    name: string;
}

const AutoLocate = ({ children, name, ...rest }: Props) => {
    const [, , helpers] = useField(name);
    const [loading, setLoading] = useState(false);

    async function handleLocation() {
        setLoading(true);
        try {
            const address = await getCurrentPickupLocation();
            if (!address) return;
            helpers.setValue(address);
        } catch {
            enqueueSnackbar(
                "We couldn't get your current position. Defaults have been used instead",
                { variant: "info" }
            );
        }
        setLoading(false);
    }
    return (
        <Stack
            direction="row"
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
            {...rest}
        >
            {children}
            {loading ? (
                <CircularProgress color="success" size={25} />
            ) : (
                <IconButton
                    size="small"
                    title="Autofill current location"
                    sx={{ border: 1, borderColor: "grey.300" }}
                    onClick={handleLocation}
                >
                    <GpsFixedOutlined />
                </IconButton>
            )}
        </Stack>
    );
};

export default AutoLocate;
